import _ from 'lodash';

export const ENV_DEV = _.includes(window.location.href, '.dev');
export const ENV_QA = _.includes(window.location.href, '.qa.');
export const ENV_PP = _.includes(window.location.href, '.pp.');
export const ENV_PROD = _.includes(window.location.href, '.jvsonline.fr');
export const ENV_LOCAL = !ENV_DEV && !ENV_QA && !ENV_PP && !ENV_PROD;

export const getEnv = () => {
  if (_.includes(window.location.href, '.jvsonline.fr')) return 'production';
  if (_.includes(window.location.href, '.qa.')) return 'testing';
  if (_.includes(window.location.href, '.pp.')) return 'staging';
  return 'development';
};
